import React, { useState, useEffect, useRef, useMemo } from "react";
import { Menu, Dropdown, Icon, Tooltip } from "antd";
import { useHistory } from "react-router-dom";
import Tab, { TabItem } from "./RecurringTabs/Tabs";
import editIcon from "../../../../assets/images/budget/dropdown.png";
import filterIcon from "../../../../assets/images/budget/filter.png";
import helpIcon from "../../../../assets/images/DeathModuleNew/IC_Help.png";
import settingIcon from "../../../../assets/SVGs/setting.svg";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import "../AddTransaction/AddTransaction.css";
import { AccountTransaction } from "./RecurringTabs/AccountTransaction";
import DEATH_API from "../../../../apis/death.api";
import swal from "sweetalert";
import BUDGET_API from "../../../../apis/budget.api";
import { RecurringPrediction } from "./RecurringTabs/RecurringPrediction";
import { SystemRecurringTransactions } from "../RecurringPattren/SystemRecurringTransactions";
import { debounce } from "lodash";
import RecurringCombined from "./RecurringTabs/RecurringCombined";
import HiddenRecurringTable from "./RecurringTabs/HiddenRecurringTable";
export const Recurring = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index) => {
    setSelectedIndex(index);
  };
  const [filter, setFilter] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [clientTransactions, setClientTransactions] = useState(null);
  const [allTransactions, setAllTransactions] = useState(null);
  const [allHiddenTransactions, setAllHiddenTransactions] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [query, setQuery] = useState("");
  
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [systemTotalPages, setSystemTotalPages] = useState(1);
  const [systemCache, setSystemCache] = useState({});
  const [systemRecurringTransactions, setSystemRecurringTransactions] = useState([])
  const [limit, setLimit] = useState(10);
  const [originalTransactions, setOriginalTransactions] = useState([]);
  const [originalHiddenTransactions, setOriginalHiddenTransactions] = useState([]);

  const PAGE_SIZE = 20;

  const financialAccess =
    localStorage.getItem("financialAccess") != "undefined" &&
    JSON.parse(localStorage.getItem("financialAccess") || null);

    const latestQueryRef = useRef("");

  const debouncedSearch = useMemo(() => {
      return debounce((searchText) => {
        latestQueryRef.current = searchText; // track latest valid search
        getRecurringTransactionsData( searchText);
      }, 500);
    }, []);

    useEffect(() => {
      const normalizedQuery = query.trim().replace(/\s+/g, " ");
      latestQueryRef.current = query;
    
      if (normalizedQuery.trim() === "") {
        // If query is empty, cancel any pending debounced call
        debouncedSearch.cancel();
        setAllTransactions([]);
        getRecurringTransactionsData( ""); // fetch    default list
      } else {
        setAllTransactions([]);
        debouncedSearch(normalizedQuery); // debounced search
      }
    }, [query]);

  const getPredictedTransactions = async (page, limit) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchRecurringPrediction(page, limit);
      if (data && data.data) {
        console.log("data", data.data);
        const allRecurring = data.data;
        setAllTransactions(allRecurring);
        setTotalPages(Math.round(data.total / limit));
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleFilter = async (type) => {
    console.log("type", type);
    setFilter(type);
    let sortedData;
    switch (type) {
      case "category":
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            if (a.categoryFromPlaid && b.categoryFromPlaid) {
              return a.categoryFromPlaid.localeCompare(b.categoryFromPlaid);
            } else {
              return 0; // No sorting if category name is missing
            }
          });
        break;
      case "Amount": // Corrected to match potential input cases
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            return a.amount - b.amount;
          });
        break;
      case "Account":
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            if (a.accountType && b.accountType) {
              return a.accountType.localeCompare(b.accountType);
            } else {
              return 0; // No sorting if account type is missing
            }
          });
        break;
      case "Due Date":
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            return new Date(a.dueDate) - new Date(b.dueDate);
          });
        break;
      case "Alphabetical": // Sorting alphabetically
        sortedData =
          allTransactions &&
          [...allTransactions].sort((a, b) => {
            if (a.itemName && b.itemName) {
              return a.itemName.localeCompare(b.itemName);
            } else {
              return 0; // No sorting if item name is missing
            }
          });
        break;
      default:
        sortedData = allTransactions && [...allTransactions];
    }
    console.log("sorted Data", sortedData);
    manageSortedData(sortedData);
  };
  const manageSortedData = (data) => {
    // const allAccount = data;
    const allRecurring = data;
    // const allRecurring = data.map((item) => {
    //   if (item.amount) {
    //     item.amount = -1*(item.amount);
    //   }
    //   return item;
    // });
    const allAccount = allRecurring && allRecurring.filter((item) => {
      return item.hidden !== true;
    });
    const checkingSavingData =
      allRecurring &&
      allRecurring.filter((item) => {
        return (
          (item.accountType === "checking" || item.accountType === "savings") &&
          item.categoryFromPlaid !== null &&
          item.hidden !== true
        );
      });
    const creditData =
      allRecurring &&
      allRecurring.filter((item) => {
        return (
          item.accountType === "credit card" &&
          item.categoryFromPlaid !== null &&
          item.hidden !== true
        );
      });
    const investmentData =
      allRecurring &&
      allRecurring.filter((item) => {
        return (
          item.accountType === "mortgage" &&
          item.categoryFromPlaid !== null &&
          item.hidden !== true
        );
      });
    const studentData =
      allRecurring &&
      allRecurring.filter((item) => {
        return (
          item.accountType === "student" &&
          item.categoryFromPlaid !== null &&
          item.hidden !== true
        );
      });
    const nullCategoryDataNullCategory =
      allRecurring &&
      allRecurring.filter((item) => {
        return item.categoryFromPlaid === null && item.hidden !== true;
      });
    const hiddenTransactions =
      allRecurring &&
      allRecurring.filter((item) => {
        return item.hidden === true;
      });
    const resultObject = {
      allAccount,
      checkingSavingData,
      creditData,
      investmentData,
      studentData,
      nullCategoryDataNullCategory,
      hiddenTransactions,
    };
    setAllTransactions(allAccount);
    setTransactions(resultObject);
  };

  const filteredTransactions = async () => {
    // const allAccount = allTransactions && allTransactions;
    const allRecurring = allTransactions && allTransactions;
    // const allRecurring = allTransactions && allTransactions.map((item) => {
    //   if (item.amount) {
    //     item.amount = -1*(item.amount);
    //   }
    //   return item;
    // });
    const allAccount =
      allRecurring &&
      allRecurring.filter((item) => {
        return item.hidden !== true;
      });
    const checkingSavingData =
      allRecurring &&
      allRecurring.filter((item) => {
        return (
          (item.accountType === "checking" || item.accountType === "savings") &&
          item.categoryFromPlaid !== null &&
          item.hidden !== true
        );
      });
    const creditData =
      allRecurring &&
      allRecurring.filter((item) => {
        return (
          item.accountType === "credit card" &&
          item.categoryFromPlaid !== null &&
          item.hidden !== true
        );
      });
    const investmentData =
      allRecurring &&
      allRecurring.filter((item) => {
        return (
          item.accountType === "mortgage" &&
          item.categoryFromPlaid !== null &&
          item.hidden !== true
        );
      });
    const studentData =
      allRecurring &&
      allRecurring.filter((item) => {
        return (
          item.accountType === "student" &&
          item.categoryFromPlaid !== null &&
          item.hidden !== true
        );
      });
    const nullCategoryDataNullCategory =
      allRecurring &&
      allRecurring.filter((item) => {
        return item.categoryFromPlaid === null && item.hidden !== true;
      });
    const hiddenTransactions =
      allRecurring &&
      allRecurring.filter((item) => {
        return item.hidden === true;
      });
    const resultObject = {
      allAccount,
      checkingSavingData,
      creditData,
      investmentData,
      studentData,
      nullCategoryDataNullCategory,
      hiddenTransactions,
    };
    setTransactions(resultObject);
    setAllTransactions(allAccount);
  };

  const deleteRecurringTransaction = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Recurring Transaction?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deletedIds = {
            recurringIds: [id],
          };
          await DEATH_API.deleteMultipleRecurringTransaction(deletedIds);
          setLoading(false);
          // if (filter) {
          //   console.log("filter",filter)
          //   await getTransactions();
          //   await handleFilter(filter);
          // } else {
          setFilter(null);
          // await getPredictedTransactions();
          await getRecurringTransactionsData();
          // }
          // setUpdateState(!updateState);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Transaction has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Transaction is safe :)", "error");
      }
    });
  };
  const deleteRecurringTransactionForNewPattern = async (id) => {
      // Redirect the user
        try {
          setLoading(true);
          let deletedIds = {
            recurringIds: [id],
          };
          await DEATH_API.deleteMultipleRecurringTransaction(deletedIds);
          setLoading(false);
          // if (filter) {
          //   console.log("filter",filter)
          //   await getTransactions();
          //   await handleFilter(filter);
          // } else {
          setFilter(null);
          // await getPredictedTransactions();
          await getRecurringTransactionsData();
          // }
          // setUpdateState(!updateState);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      
    
  };

  const hideRecurringTransaction = async (id, page) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Hide this Recurring Transaction?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Hide it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deletedIds = {
            recurringIds: [id],
            hidden: true,
          };
          await DEATH_API.hideRecurringTransaction(deletedIds);
          setLoading(false);
          setFilter(null);
          // await getPredictedTransactions(page, 10);
          await getRecurringTransactionsData();
          await getHiddenRecurringTransactionsData();
          await fetchSystemRecurringPages();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Hidden!", "Your Transaction has been Hidden.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Transaction is safe :)", "error");
      }
    });
  };
  const unhideRecurringTransaction = async (id, page) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to UnHide this Recurring Transaction?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, UnHide it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deletedIds = {
            recurringIds: [id],
            // hidden: true,
          };
          await DEATH_API.unhideRecurringTransaction(deletedIds);
          setLoading(false);
          setFilter(null);
          // await getPredictedTransactions(page, 10);
          await getRecurringTransactionsData();
          await getHiddenRecurringTransactionsData();
          await fetchSystemRecurringPages();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Hidden!", "Your Transaction has been unHidden.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Transaction is safe :)", "error");
      }
    });
  };
  const deleteToken = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Recurring Rule?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let payload = { tokenId: id };
          const res = await BUDGET_API.deleteRecurringToken(payload);
          if (res && res.statusCode === 200) {
            // setCachedData({});
            // await getRecurringTokenAfterDelete(1);
            await getRecurringTransactionsData();
            await fetchSystemRecurringPages();
            // setFetchRecuuring(!fetchRecuuring);
            swal(
              "Deleted!",
              "Your Recurring Rule has been deleted.",
              "success"
            );
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Recurring Rule is safe :)", "error");
      }
    });
  };
  const restoreRecurringTransaction = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Restore this Recurring Transaction?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Restore it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deletedIds = {
            recurringIds: [id],
            hidden: false,
          };
          await DEATH_API.hideRecurringTransaction(deletedIds);
          setLoading(false);
          setFilter(null);
          await getPredictedTransactions(1,10);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Restored!", "Your Transaction has been Restored.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Transaction is safe :)", "error");
      }
    });
  };
  // useEffect(() => {
  //   getAll();
  // }, []);
  // const getAll = async () => {
  //   await getPredictedTransactions(currentPage,limit);
  // };

  const searchData = (transactions, query) => {
    const lowercaseQuery = query.toLowerCase();
    let arrayToSearch = [];
    let tabIndex = selectedIndex;
    // Determine which array to search based on the tab index from state
    switch (tabIndex) {
      case 0: // All Accounts
        arrayToSearch = transactions.allAccount;
        break;
      case 1: // Checking/Saving
        arrayToSearch = transactions.checkingSavingData;
        break;
      case 2: // Credit Data
        arrayToSearch = transactions.creditData;
        break;
      // case 3: // Investments
      //   arrayToSearch = transactions.investmentData;
      //   break;
      // case 4: // Student Data
      //   arrayToSearch = transactions.studentData;
      // case 3: // uncategorized Data
      //   arrayToSearch = transactions.nullCategoryDataNullCategory;
      //   break;
      case 3: // uncategorized Data
        arrayToSearch = transactions.hiddenTransactions;
        break;
      default:
        break;
    }
    // Perform the search
    return arrayToSearch && arrayToSearch.filter((item) => {
      const description = item.description
        ? item.description.toLowerCase()
        : "";
      const notes = item.notes ? item.notes.toLowerCase() : "";
      const itemName = item.itemName ? item.itemName.toLowerCase() : "";
      const categoryFromPlaid = item.categoryFromPlaid
        ? item.categoryFromPlaid.toLowerCase()
        : "";
      const subCategory = item.subCategory
        ? item.subCategory.toLowerCase()
        : "";
      const amountString = item.amount
        ? item.amount.toString().toLowerCase()
        : "";
      // const dateString = item.date ? item.date.toLowerCase() : '';
      const dateString = item.date
        ? new Date(item.date)
            .toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
            .replace(/\//g, "-")
        : "";
      return (
        description.includes(lowercaseQuery) ||
        notes.includes(lowercaseQuery) ||
        itemName.includes(lowercaseQuery) ||
        categoryFromPlaid.includes(lowercaseQuery) ||
        subCategory.includes(lowercaseQuery) ||
        amountString.includes(lowercaseQuery) || // Search in amount
        dateString.includes(lowercaseQuery) // Search in date
      );
    });
  };
  const filteredData =
    transactions && transactions ? searchData(transactions, searchQuery) : [];

  const selectedRowsDataKeys = (data) => {
    setSelectedRowKeys(data);
  };
  const deleteSelectedTransaction = async () => {
    const isMultiple = selectedRowKeys && selectedRowKeys.length > 1;
    const textMessage = isMultiple
      ? "Are you sure you want to delete these transactions?"
      : "Are you sure you want to delete this transaction?";

    const successMessage = isMultiple
      ? "Your transactions have been deleted."
      : "Your transaction has been deleted.";

    const cancelMessage = isMultiple
      ? "Your Transactions are safe :)"
      : "Your Transaction is safe :)";

    swal({
      title: "Are you sure?",
      text: textMessage,
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deleteIds = {
            recurringIds: selectedRowKeys,
          };
          await DEATH_API.deleteMultipleRecurringTransaction(deleteIds);
          setSelectedRowKeys([]);
          setLoading(false);
          setFilter(null);
          await getPredictedTransactions(1,10);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", successMessage, "success");
        }, 0);
      } else {
        swal("Cancelled", cancelMessage, "error");
      }
    });
  };
  const hideSelectedTransaction = async () => {
    const isMultiple = selectedRowKeys && selectedRowKeys.length > 1;
    const textMessage = isMultiple
      ? "Are you sure you want to Hide these transactions?"
      : "Are you sure you want to Hide this transaction?";

    const successMessage = isMultiple
      ? "Your transactions have been Hidden."
      : "Your transaction has been Hidden.";

    const cancelMessage = isMultiple
      ? "Your Transactions are safe :)"
      : "Your Transaction is safe :)";

    swal({
      title: "Are you sure?",
      text: textMessage,
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Hide it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deleteIds = {
            recurringIds: selectedRowKeys,
            hidden: true,
          };
          await DEATH_API.hideRecurringTransaction(deleteIds);
          setSelectedRowKeys([]);
          setLoading(false);
          setFilter(null);
          await getPredictedTransactions(1,10);
          await getRecurringTransactionsData();
          await getHiddenRecurringTransactionsData();
          await fetchSystemRecurringPages();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Hidden!", successMessage, "success");
        }, 0);
      } else {
        swal("Cancelled", cancelMessage, "error");
      }
    });
  };
  const restoreSelectedTransaction = async () => {
    const isMultiple = selectedRowKeys && selectedRowKeys.length > 1;
    const textMessage = isMultiple
      ? "Are you sure you want to Restore these transactions?"
      : "Are you sure you want to Restore this transaction?";

    const successMessage = isMultiple
      ? "Your transactions have been Restored."
      : "Your transaction has been Restored.";

    const cancelMessage = isMultiple
      ? "Your Transactions are safe :)"
      : "Your Transaction is safe :)";

    swal({
      title: "Are you sure?",
      text: textMessage,
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Restore it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let deleteIds = {
            recurringIds: selectedRowKeys,
            hidden: false,
          };
          await DEATH_API.hideRecurringTransaction(deleteIds);
          setSelectedRowKeys([]);
          setLoading(false);
          setFilter(null);
          await getPredictedTransactions(1,10);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Restored!", successMessage, "success");
        }, 0);
      } else {
        swal("Cancelled", cancelMessage, "error");
      }
    });
  };

  const handleChange = (e) => {
    const rawInput = e.target.value;

    const sanitized = rawInput.replace(/[^a-zA-Z0-9\s]/g, "");

    // Step 2: Replace multiple spaces with one (but NOT trimming yet, to allow natural typing)
    const singleSpaced = sanitized.replace(/\s{2,}/g, " ");
    setQuery(singleSpaced);
  };

  const getRecurringTransactionsData = async (searchQuery="") => {
      try {
        setLoading(true);
        const response = await DEATH_API.getRecurringTransaction(searchQuery);
        if (response && response.data) {
          const allAccount = response.data.filter((item) => {
            return item.hidden !== true;
          });
          setOriginalTransactions(allAccount);
          setAllTransactions(allAccount);
        }else{
          setOriginalTransactions([]);
          setAllTransactions([]);
        }
      } catch (error) {
        console.error("Error fetching recurring transactions:", error);
      } finally {
        setLoading(false);
      }
    };
  const getHiddenRecurringTransactionsData = async (searchQuery="") => {
      try {
        setLoading(true);
        const response = await DEATH_API.getRecurringTransaction(searchQuery,true);
        if (response && response.data) {
          const allAccount = response.data.filter((item) => {
            return item.hidden === true;
          });
          setOriginalHiddenTransactions(allAccount);
          setAllHiddenTransactions(allAccount);
        }else{
          setAllHiddenTransactions([]);
        }
      } catch (error) {
        console.error("Error fetching Hidden recurring transactions:", error);
      } finally {
        setLoading(false);
      }
    };
    // const getSystemPage = async (page) => {
    //   if (systemCache[page]) return systemCache[page];
  
    //   const response = await BUDGET_API.fetchSystemRecurringTransactions(page);
    //   // console.log('ress----------------',count,page,currentPage,response)
    //   // setCount(count+1)
    //   if (response && response.data && response.data.transactions) {
    //     setSystemCache((prev) => ({ ...prev, [page]: response.data.transactions }));
    //     setSystemTotalPages(response.data.totalPages || 1);
    //     return response.data.transactions;
    //   }
    //   return [];
    // };
    // const getSystemRecurringTransactionsData = async () => {
    //   try {
    //     setLoading(true);
    //     const start = (currentPage - 1) * PAGE_SIZE;
    //     const end = start + PAGE_SIZE;
    //     let systemItems = [];
    //     let page = 1;
    
    //     // Keep fetching system pages until we have enough items
    //     while (systemItems.length < end && page <= systemTotalPages) {
    //       const pageData = await getSystemPage(page);
    //       systemItems = [...systemItems, ...pageData];
    //       page++;
    //     }
    //    setSystemRecurringTransactions(systemItems)
    //   } catch (error) {
    //     console.error("Error fetching recurring transactions:", error);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    const fetchSystemRecurringPages = async () => {
      try {
        setLoading(true);
    
        const start = (currentPage - 1) * PAGE_SIZE;
        const end = start + PAGE_SIZE;
    
        let systemItems = [];
        let page = 1;
        
        while (systemItems.length < end && page <= systemTotalPages) {
          // if (systemCache[page]) {
            //   systemItems = [...systemItems, ...systemCache[page]];
            // } else {
              const response = await BUDGET_API.fetchSystemRecurringTransactions(page);
            if (response && response.data && response.data.transactions) {
              const pageData = response.data.transactions;
              setSystemCache((prev) => ({ ...prev, [page]: pageData }));
              setSystemTotalPages(response.data.totalPages || 1);
              systemItems = [...systemItems, ...pageData];
              // }
            }
            page++;
          }
    
        setSystemRecurringTransactions(systemItems);
      } catch (error) {
        console.error("Error fetching system recurring transactions:", error);
      } finally {
        setLoading(false);
      }
    };
    
    
  useEffect(() => {
    getRecurringTransactionsData();
    getHiddenRecurringTransactionsData("");
    fetchSystemRecurringPages()
  }, []);

  const Tabs = [
    // {
    //   id: 1,
    //   name: "Recurring Prediction",
    //   tooltip:
    //     "Predictions are transactions detected by the system as potentially recurring, based on patterns in your financial activity.",
    //   component: <RecurringPrediction setAllTransactions={setAllTransactions} allTransactions={allTransactions} />,
      // component: (
      //   <AccountTransaction
      //     transactions={filteredData && filteredData}
      //     clientTransactions={clientTransactions && clientTransactions}
      //     deleteTransaction={deleteRecurringTransaction}
      //     selectedRowsDataKeys={selectedRowsDataKeys}
      //     selectedRowKeys={selectedRowKeys}
      //     hideRecurringTransaction={hideRecurringTransaction}
      //     restoreRecurringTransaction={restoreRecurringTransaction}
      //     tabName="All Accounts"
      //   />
      // ),
    // },
    // {
    //   id: 2,
    //   name: "System Recuuring Transactions",
    //   tooltip:
    //     "System recurring transactions are those explicitly defined by the user through recurring rules and patterns.",
    //   component: <SystemRecurringTransactions />,
      // component: (
      //   <AccountTransaction
      //     // transactions={transactions && transactions.checkingSavingData}
      //     transactions={filteredData && filteredData}
      //     clientTransactions={clientTransactions && clientTransactions}
      //     deleteTransaction={deleteRecurringTransaction}
      //     selectedRowsDataKeys={selectedRowsDataKeys}
      //     selectedRowKeys={selectedRowKeys}
      //     hideRecurringTransaction={hideRecurringTransaction}
      //     restoreRecurringTransaction={restoreRecurringTransaction}
      //     tabName="Checking and Saving"
      //   />
      // ),
    // },
    {
      id: 3,
      name: "Recurring",
      tooltip:
        "Combined Predictions and System Recurring. Predictions are transactions detected by the system as potentially recurring, based on patterns in your financial activity and System recurring transactions are those explicitly defined by the user through recurring rules and patterns.",
      component: <RecurringCombined fetchSystemRecurringPages={fetchSystemRecurringPages} setAllTransactions={setAllTransactions} allTransactions={allTransactions} systemRecurringTransactions={systemRecurringTransactions} hideRecurringTransaction={hideRecurringTransaction} deleteRecurringTransaction={deleteRecurringTransactionForNewPattern} deleteToken={deleteToken} getRecurringTransactionsData={getRecurringTransactionsData} systemTotalPages={systemTotalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} selectedRowKeys={selectedRowKeys} selectedRowsDataKeys={selectedRowsDataKeys} />,
      // component: (
      //   <AccountTransaction
      //     transactions={filteredData && filteredData}
      //     clientTransactions={clientTransactions && clientTransactions}
      //     deleteTransaction={deleteRecurringTransaction}
      //     selectedRowsDataKeys={selectedRowsDataKeys}
      //     selectedRowKeys={selectedRowKeys}
      //     hideRecurringTransaction={hideRecurringTransaction}
      //     restoreRecurringTransaction={restoreRecurringTransaction}
      //     tabName="All Accounts"
      //   />
      // ),
    },
    {
      id: 4,
      name: "Hidden Recurring",
      tooltip:
        "Hidden transactions are transtions from Pridiction that you have hide on purpose.",
      component: <HiddenRecurringTable setAllTransactions={setAllHiddenTransactions} allTransactions={allHiddenTransactions} hideRecurringTransaction={hideRecurringTransaction} unhideRecurringTransaction={unhideRecurringTransaction} />,
     
    }

    // {
    //   id: 5,
    //   name: "Hidden",
    //   component: (
    //     <AccountTransaction
    //       // transactions={transactions && transactions.creditData}
    //       transactions={filteredData && filteredData}
    //       clientTransactions={clientTransactions && clientTransactions}
    //       deleteTransaction={deleteRecurringTransaction}
    //       selectedRowsDataKeys={selectedRowsDataKeys}
    //       selectedRowKeys={selectedRowKeys}
    //       hideRecurringTransaction={hideRecurringTransaction}
    //       restoreRecurringTransaction={restoreRecurringTransaction}
    //       tabName="Hidden"
    //     />
    //   ),
    // },
  ];
  const userRole = localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client"
 
  return (
    <div className="addBudgetMain" style={{ position: "relative" }}>
      <div className="addbudgetSection">
        <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
          <div className="addTitle">
            Recurring{" "}
            <span>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget");
                        }}
                      >
                        Dashboard
                      </div>
                    </Menu.Item>
                    {(!financialAccess || !financialAccess.hideTransactions) && (
                      <Menu.Item>
                        <div
                          onClick={() => {
                            history.push("/budget/add/transaction");
                          }}
                        >
                          Transactions
                        </div>
                      </Menu.Item>
                    )}
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/budget");
                        }}
                      >
                        Budget
                      </div>
                    </Menu.Item>
                    {(!financialAccess || !financialAccess.hideTransactions) && (
                      <Menu.Item
                      //   style={{ cursor: "not-allowed", opacity: "0.7" }}
                      >
                        <div
                          onClick={() => {
                            history.push("/budget/transaction/recurring");
                          }}
                        >
                          Recurring
                        </div>
                      </Menu.Item>
                    )}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={editIcon} height={12} width={18} alt="icon"></img>
                </a>
              </Dropdown>
            </span>
          </div>
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            {filter && filter && (
              <div className="savebutton" style={{ width: "fit-content" }}>
                By {filter}
                <span
                  className="custom-footer-text"
                  onClick={() => {
                    setFilter(null);
                    manageSortedData([...originalTransactions]);
                  }}
                >
                  <Icon
                    type="close-circle"
                    style={{
                      marginBottom: "3px",
                      marginLeft: "8px",
                      fontWeight: "800",
                      fontSize: "18px",
                    }}
                  />{" "}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="budgetcreate" style={{ gap: "1rem" }}>
          <div style={{ marginBottom: "0px" }}>
            <input
              style={{ marginBottom: "0px" }}
              className="searchStyle"
              placeholder="Search"
              value={query}
              onChange={handleChange}
              onPaste={(e) => {
                e.preventDefault();
                const pasted = e.clipboardData
                  .getData("text")
                  .replace(/[^a-zA-Z0-9\s]/g, "")
                  .replace(/\s{2,}/g, " ");
                setQuery(pasted);
              }}
            />
          </div>
          <div className="filterIcons">
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu>
                  <div
                    style={{
                      fontWeight: "bolder",
                      paddingInline: "12px",
                      marginBottom: "8px",
                      marginTop: "8px",
                    }}
                  >
                    Type
                  </div>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        handleFilter("Account");
                      }}
                    >
                      Account
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        handleFilter("Amount");
                      }}
                    >
                      Amount
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        handleFilter("Due Date");
                      }}
                    >
                      Due Date
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        handleFilter("Alphabetical");
                      }}
                    >
                      Alphabetical
                    </div>
                  </Menu.Item>
                </Menu>
              }
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <img src={filterIcon} height={24} width={24} alt="icon"></img>
              </a>
            </Dropdown>
          </div>
          {(!financialAccess || !financialAccess.hideTransactions) && <button
            className="addbuttonassets"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/budget/transaction/recurring/rules");
            }}
          >
            + Add Rule
          </button>}
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "end",
          justifyContent: "end",
          gap: "1rem",
          position:'relative'
        }}
      >
      {selectedRowKeys && selectedRowKeys.length > 0 && userRole && (
          <button
            className="savebutton"
            style={{ width: "fit-content" }}
            onClick={() => {
              hideSelectedTransaction();
            }}
          >
            {" "}
            Hide Multiple{" "}
          </button>
        )}
      </div>
      <div className="TabSection">
      <Tab onTabSelected={onTabSelected}>
          {Tabs.map((tab, index) => (
            <TabItem key={tab.id}>
              {tab.name}{" "}
              <Tooltip title={tab.tooltip}>
                <img
                  style={{
                    cursor: "pointer",
                    marginLeft: "8px",
                    width: "25px",
                    height: "25px",
                  }}
                  src={helpIcon}
                  alt="helpicon"
                ></img>
              </Tooltip>
            </TabItem>
          ))}
        </Tab>
      </div>
      {/*<div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "end",
          justifyContent: "end",
          gap: "1rem",
        }}>
        {selectedRowKeys && selectedRowKeys.length > 0 && (
          <button
            className="savebutton"
            style={{ width: "fit-content" }}
            onClick={() => {
              if(selectedIndex===3){
                restoreSelectedTransaction()
              }
              else{
                hideSelectedTransaction();
              }
              // deleteSelectedTransaction();
            }}>
            {" "}
            Edit Multiple{" "}
          </button>
        )}
      </div> */}
      <div className="ComponentSection">{Tabs[selectedIndex].component}</div>

      <NewLoader isLoading={loading} />
      {/* <Loader isLoading={loading} /> */}
    </div>
  );
};
